import { render } from "./ProductBanner.vue?vue&type=template&id=3538f063&scoped=true"
import script from "./ProductBanner.vue?vue&type=script&lang=js"
export * from "./ProductBanner.vue?vue&type=script&lang=js"

import "./ProductBanner.vue?vue&type=style&index=0&id=3538f063&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3538f063"]])

export default __exports__